import { ComponentType } from 'react';

import { CoinsHandIcon } from '@/components/icons/CoinsHandIcon';
import { Home03Icon } from '@/components/icons/Home03Icon';
import { IconProps, User01Icon } from '@/components/icons/User01Icon';

export type EstateCategory =
  | 'in-estate'
  | 'out-of-estate-family'
  | 'out-of-estate-charity';

export const ESTATE_CATEGORY_ICON: Record<
  EstateCategory,
  ComponentType<IconProps>
> = {
  'in-estate': User01Icon,
  'out-of-estate-family': Home03Icon,
  'out-of-estate-charity': CoinsHandIcon,
};
